/*
 *    Controller to show a user profile
 *    Triggered via:
 *        Radio.request(
 *          'show_profile',
 *          {{ACCOUNT}}
 *        );
 *    Arguments:
 *        ACCOUNT: Object. Backbone Model extended v5API "Model", specifically instance of models/v5/account.js
*/

import Radio from 'backbone.radio';
import ProfileView from '@/views/profile';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';
var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');

function show_profile(account) {
    var app_container = globalCh.request('app_layout');
    var profile_view = new ProfileView({
        model: account,
    });

    app_container.showChildView('container', profile_view);

    globalCh.request('show_secondary_nav', { empty: true });

    globalCh.request('show_profile_nav', { selected: 'profile-home'});

    routerCh.request('set_location', 'profile', account);

    app_container.showChildView('main_nav', new BreadcrumbNavLayout());
    globalCh.request('changeActiveAccount', account, function () {
        globalCh.request('set_selection', {
            type: 'app',
            id: 'home'
        });
    });
}

export default show_profile;


